import { HiArrowLeft } from 'react-icons/hi'

import {
  As,
  Box,
  Flex,
  HStack,
  Icon,
  IconButton,
  SkeletonCircle,
  Spacer,
} from '@chakra-ui/react'

import {
  DeviceHealthPopover,
  DrawerBreadcrumb,
  DrawerTextClipboard,
} from '@/components/ui'
import { IncidentQueryResult } from '@/graphql/generated/hooks'
import { DeviceStatus } from '@/graphql/generated/schemas'

import { getOrigin } from '../utils/helpers'

const CustomIcon = ({ as, fontSize }: { as: As<any>; fontSize: string }) => {
  return <Icon as={as} fontSize={fontSize} />
}

interface IncidentDrawerHeaderIProps {
  incident: IncidentQueryResult['data']['incident']
  isLoading: boolean
  onClose: () => void
}

export const IncidentDrawerHeader = ({
  incident,
  isLoading,
  onClose,
}: IncidentDrawerHeaderIProps) => {
  const origin = getOrigin()

  const device = incident?.devices?.[0]
  const displayId = incident?.displayId

  const incidentLink =
    origin && displayId ? `${origin}/incidents/?displayId=${displayId}` : ''

  return (
    <Flex bg='white' h='64px' w='full'>
      <HStack isTruncated pl='24px'>
        <IconButton
          aria-label='close incident drawer'
          borderRadius='md'
          h='30px'
          icon={<CustomIcon as={HiArrowLeft} fontSize='18px' />}
          minWidth='30px'
          onClick={onClose}
          variant='ghost'
          w='30px'
        />
        <DrawerBreadcrumb
          dataTestId='incidentDrawer_header_incidentName'
          isLoading={isLoading}
          label={incident?.name}
          maxWidth='100%'
        />
        {/* Hacky way to get around uneven spacing around the divider that occurs before this */}
        <Box paddingLeft={1}>
          <DrawerTextClipboard
            copyMessage='Copy link to incident'
            fontWeight='normal'
            hideDivider={true}
            isLoading={isLoading}
            label={displayId}
            link={incidentLink}
          />
        </Box>
      </HStack>
      <Spacer />
      {device && (
        <HStack spacing='18px'>
          {isLoading ? (
            <SkeletonCircle size='30px' />
          ) : (
            <DeviceHealthPopover
              deviceIsUnhealthy={device?.status === DeviceStatus.Unhealthy}
            />
          )}
        </HStack>
      )}
    </Flex>
  )
}
